import { Box } from "@mui/material";
import { useRef } from "react";
//import useScrollPosition from "../../hook/useScrollPosition";

export const VerticalSlider = ({ title }: any) => {
  const elementRef = useRef(null);
  //const { top } = useScrollPosition(elementRef);

  return (
    <Box
      ref={elementRef}
      sx={{
        mx: "20px",
        borderRadius: "20px",
        //height: top > 150 ? "0px" : "200px",
      }}
    />
  );
};
